import { Grid } from '@cko/primitives';
import styled from 'styled-components';
import { grid } from 'styled-system';
const columnGap = 'var(--layout-soybean)';
const rowGap = 'var(--layout-shoe)';
// Grid defined on this Figma design: // https://www.figma.com/file/EeLg5STrbkx5i9JL92bo81/3.-Payments?node-id=1583%3A46551
/**
 * @deprecated - Please use the LayoutGrid Component from UI Toolkit
 * {@link https://frontend-ds.cko-dev.ckotech.co/?path=/docs/layoutgrid--docs}
 */
export const GridContainer = styled(Grid) `
  grid-gap: ${columnGap} ${rowGap};
  grid-template-columns: repeat(auto-fill, minmax(480px, 1fr));
  ${grid}
`;
